function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 0C4.2617 0 0 4.26176 0 9.50006C0 14.7384 4.2617 19 9.5 19C14.7383 19 19 14.7384 19 9.50006C19 4.26176 14.7383 0 9.5 0ZM9.5 17.2727C5.21406 17.2727 1.72727 13.7859 1.72727 9.50006C1.72727 5.21418 5.21406 1.72727 9.5 1.72727C13.7859 1.72727 17.2727 5.21418 17.2727 9.50006C17.2727 13.7859 13.7859 17.2727 9.5 17.2727Z",
  fill: "white"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.49984 4.0303C8.86501 4.0303 8.34856 4.5471 8.34856 5.18234C8.34856 5.81699 8.86501 6.33333 9.49984 6.33333C10.1347 6.33333 10.6511 5.81699 10.6511 5.18234C10.6511 4.5471 10.1347 4.0303 9.49984 4.0303Z",
  fill: "white"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.5 8.06061C9.02305 8.06061 8.63637 8.44729 8.63637 8.92424V14.1061C8.63637 14.583 9.02305 14.9697 9.5 14.9697C9.97696 14.9697 10.3636 14.583 10.3636 14.1061V8.92424C10.3636 8.44729 9.97696 8.06061 9.5 8.06061Z",
  fill: "white"
});

var SvgInfo = function SvgInfo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info.b5577f38.svg";
export { ForwardRef as ReactComponent };